import { render, staticRenderFns } from "./TitleDetailSimilarTitlesV2.vue?vue&type=template&id=4f5ba8e8"
import script from "./TitleDetailSimilarTitlesV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleDetailSimilarTitlesV2.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports